import { FC } from "react";
import { FormHelperText, FormHelperTextProps } from "@mui/material";

export type HErrorMessageProps = {
  errorMessage: string | undefined;
} & FormHelperTextProps;

const HErrorMessage: FC<HErrorMessageProps> = ({ errorMessage, ...props }) => {
  const hasError = !!errorMessage;
  if (!hasError) {
    return null;
  }
  return (
    <FormHelperText error={hasError} {...props} role="status">
      {errorMessage}
    </FormHelperText>
  );
};

export { HErrorMessage };
